(() => {
    'use strict';

    const initSearchModal = (scope = document) => {
      const root = scope && scope.querySelector ? scope : document;
      const modal = root.querySelector('#search-modal') || document.querySelector('#search-modal');

      if (!modal || modal.dataset.mellerSearchModalInit === 'true') return;

      const dialog = modal.querySelector('dialog');

      if (!dialog) return;

      const input = dialog.querySelector('.search-input');
      const results = dialog.querySelector('[ref="predictiveSearchResults"]');
      const resetButton = dialog.querySelector('.predictive-search__reset-button');
      const component = dialog.querySelector('predictive-search-component');

      if (!input || !results) return;

      modal.dataset.mellerSearchModalInit = 'true';

      let syncFrame = 0;
      let delayedSyncTimer = 0;
      let resetFrame = 0;

      const isDialogOpen = () => dialog.hasAttribute('open');

      const clearScheduledWork = () => {
        if (syncFrame) {
          window.cancelAnimationFrame(syncFrame);
          syncFrame = 0;
        }

        if (resetFrame) {
          window.cancelAnimationFrame(resetFrame);
          resetFrame = 0;
        }

        if (delayedSyncTimer) {
          window.clearTimeout(delayedSyncTimer);
          delayedSyncTimer = 0;
        }
      };

      const setEmptyState = () => {
        results.classList.add('predictive-search-form__content--empty');
      };

      const removeEmptyState = () => {
        results.classList.remove('predictive-search-form__content--empty');
      };

      const hasInputText = () => input.value.trim().length > 0;

      const hasResultsContent = () => {
        if (results.firstElementChild) return true;

        return results.textContent.trim().length > 0;
      };

      const syncResultsState = () => {
        syncFrame = 0;

        if (!isDialogOpen()) return;

        if (hasInputText() && hasResultsContent()) {
          removeEmptyState();
        } else {
          setEmptyState();
        }
      };

      const scheduleSyncResultsState = () => {
        if (syncFrame) return;

        syncFrame = window.requestAnimationFrame(syncResultsState);
      };

      const scheduleDelayedSyncResultsState = () => {
        if (delayedSyncTimer) {
          window.clearTimeout(delayedSyncTimer);
        }

        delayedSyncTimer = window.setTimeout(() => {
          delayedSyncTimer = 0;
          scheduleSyncResultsState();
        }, 120);
      };

      const resetPredictiveSearch = () => {
        clearScheduledWork();

        input.value = '';
        input.setAttribute('aria-expanded', 'false');

        results.replaceChildren();
        setEmptyState();

        if (resetButton) {
          resetButton.hidden = true;
        }

        if (component) {
          component.classList.remove('predictive-search--expanded');
        }
      };

      const resetWithFrame = () => {
        if (resetFrame) return;

        resetFrame = window.requestAnimationFrame(() => {
          resetFrame = 0;
          resetPredictiveSearch();
        });
      };

      dialog.addEventListener('close', resetPredictiveSearch);
      dialog.addEventListener('cancel', resetWithFrame);

      modal.addEventListener('click', (event) => {
        const target = event.target;

        if (!(target instanceof Element)) return;

        if (target.closest('.predictive-search__close-modal-button') || target === dialog) {
          resetWithFrame();
        }
      });

      input.addEventListener('input', () => {
        if (!hasInputText()) {
          setEmptyState();
          return;
        }

        scheduleSyncResultsState();
        scheduleDelayedSyncResultsState();
      });

      input.addEventListener('focus', () => {
        if (!hasInputText()) {
          setEmptyState();
          return;
        }

        scheduleSyncResultsState();
      });

      const observer = new MutationObserver(() => {
        if (!isDialogOpen()) return;

        scheduleSyncResultsState();
      });

      observer.observe(results, {
        childList: true
      });

      setEmptyState();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initSearchModal(document), { once: true });
    } else {
      initSearchModal(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initSearchModal(event.target || document);
    });
  })();

